import { post, get } from "./http";
let basic = "/plan/png";
const pngApi = {
  pngListSeller: (params) => {
    return post(`/common/png/listSeller`, params);
  },
  listCrmCustomer:(params) => {
    return post(`/common/png/listCrmCustomer`, params);
  },//买家端-查询crm客户列表
  dayPlanPage: (params) => {
    return post(`${basic}/day/page`, params);
  }, //计划分页
  dayPlanExists: (params) => {
    return get(`${basic}/day/exists`, params);
  }, //检验是否已提报
  dayPlanInit: (params) => {
    return post(`${basic}/day/creation-init`, params);
  }, //初始化日计划
  dayPlanSave: (params) => {
    return post(`${basic}/day/save`, params);
  }, //保存日计划
  dayPlanSubmit: (params) => {
    return post(`${basic}/day/submit`, params);
  }, //提交日计划
  dayPlanChange: (params) => {
    return post(`${basic}/day/change`, params);
  }, //变更日计划
  dayPlanDetail: (params) => {
    return get(`${basic}/day/detail?planNo=` + params.planNo);
  }, //根据计划编号查询日计划
  dayPlanHistory: (params) => {
    return post(`${basic}/day/detail/page/history`, params);
  }, //查询日计划历史提报记录（分页）
  balanceCheck: (params) => {
    return post(`${basic}/day/balance/check`, params);
  }, //余额查询
  hasSubmitDayPlan: (params) => {
    return post(`/worktable/png/hasSubmitDayPlan`, params);
  }, //是否填报次日的日计划
  groupVolume: (params) => {
    return post(`/worktable/png/groupVolume`, params);
  }, //查询 管道气累计量
  getDayDeadline: (params) => {
     return get(`${basic}/day/getDayDeadline`, params);
  },//获取明日计划提报截止时间
};

export default pngApi;
